/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelEditTableRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EditTable<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description edit table
   *
   * @tags table
   * @name EditTableCreate
   * @summary edit table
   * @request POST:/editTable
   */
  editTableCreate = (
    request: ModelEditTableRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/editTable`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
